var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

/**
 * Get nested property value
 *
 * Usage:
 * var obj = {foo: {bar: 'ok'}};
 * opg('foo/bar', obj); // 'ok'
 *
 * @param {String} properties 'a.b.c'
 * @param {Object} obj
 * @param {*} [defaultValue] If property will not exist
 * @param {String} [delimiter] Default '/'
 */
var opg = function opg(properties, obj, defaultValue) {
  var delimiter = '/';

  if (typeof properties == 'string') {
    properties = properties.split(delimiter);
  } else {
    properties = [properties];
  }

  var property = properties.shift();

  if (!obj || typeof obj[property] == 'undefined') {
    return defaultValue;
  }

  if (properties.length) {
    properties = properties.join(delimiter);

    return opg(properties, obj[property], defaultValue, delimiter);
  } else {
    return obj[property];
  }
};

var propertiesWithoutLast = function propertiesWithoutLast(properties) {
  var delimiter = '/';

  if (typeof properties == 'string') {
    properties = properties.split(delimiter);
  }

  if (properties.length > 1) {
    properties.pop();
  }

  return properties;
};

var normalizeCondition = function normalizeCondition(conditionDescriptor) {
  if (!conditionDescriptor.all) {
    if (!conditionDescriptor.any) {
      conditionDescriptor = {
        all: conditionDescriptor
      };
    }
  }

  return conditionDescriptor;
};

/**
 * Support:
 *
 * // TODO: maybe implement short circuits for conditions
 *
 * {
 *   'path/to/elem':         'exact_value',
 *   'path/to/other_elem':   '! negated_exact_value',
 *   'path/to/other_elem_1': 'first_val | second_val | third_possible_val',
 *   'path/to/other_elem_2': '! first_val | second_val',
 * }
 */
var matchValuesWithCondition = function matchValuesWithCondition(conditionDescriptor, inferedValuesForContext) {
  var conditionsObject = Object.values(conditionDescriptor)[0];

  var maybeGetMatcher = function maybeGetMatcher(matcher) {
    if (matcher.length > 4) {
      return false;
    }

    if (matcher.indexOf('any') === 0) {
      return 'any';
    }

    if (matcher.indexOf('all') === 0) {
      return 'all';
    }

    return false;
  };

  var valuesToCheck = Object.keys(conditionsObject).map(function (singleOptionPath, index) {
    var maybeThat = Object.values(conditionsObject)[index];

    if (maybeGetMatcher(singleOptionPath) === 'all' || maybeGetMatcher(singleOptionPath) === 'any') {
      return matchValuesWithCondition(defineProperty({}, singleOptionPath, maybeThat), inferedValuesForContext);
    }

    return tryToMatchValueWithOptionPath(maybeThat, singleOptionPath, inferedValuesForContext);
  });

  if (maybeGetMatcher(Object.keys(conditionDescriptor)[0]) === 'all') {
    return valuesToCheck.every(function (v) {
      return !!v;
    });
  }

  if (maybeGetMatcher(Object.keys(conditionDescriptor)[0]) === 'any') {
    return valuesToCheck.some(function (v) {
      return !!v;
    });
  }
};

function extractScalarValueFor(singleOptionPath, inferedValuesForContext) {
  var getAsInfered = function getAsInfered(path) {
    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : inferedValuesForContext;
    return opg(path, values);
  };

  if (singleOptionPath.indexOf(':') > -1) {
    /**
     * Congrats, gentlemans, we are having a custom matcher here
     * To be honest, this is the dumbest thing I can figure out right now.
     * There probably is a better way to handle that. One could go about
     * getting an interface here or smth like that.
     *
     * WARNING: Hardcoded to ct-select.
     * Also doesn't work with ct-inherit, will report the value
     * incorrectly. Will be fixed properly when implementing the context
     * asbtraction properly.
     *
     * choices matcher
     * option_id:choices => LENGTH
     */

    var value = null;(function (thing, cb) {
      return cb(thing);
    })(singleOptionPath.split(':'), function (_ref) {
      var _ref2 = toArray(_ref),
          singleOptionPath = _ref2[0],
          matcher = _ref2.slice(1);

      // TODO: start implementing matchers after we are done with
      // everything else with Vue renderer

      matcher = matcher.join(':');

      if (matcher === 'visibility') {
        value = getAsInfered(singleOptionPath, _extends({}, inferedValuesForContext, defineProperty({}, propertiesWithoutLast(singleOptionPath), opg(propertiesWithoutLast(singleOptionPath), inferedValuesForContext)[inferedValuesForContext.wp_customizer_current_view] ? 'yes' : 'no')));
      }

      if (matcher === 'responsive') {
        value = getAsInfered(singleOptionPath, _extends({}, inferedValuesForContext, defineProperty({}, propertiesWithoutLast(singleOptionPath), opg(propertiesWithoutLast(singleOptionPath), inferedValuesForContext)[inferedValuesForContext.wp_customizer_current_view] || opg(propertiesWithoutLast(singleOptionPath), inferedValuesForContext))));
      }

      if (matcher === 'truthy') {
        value = !!getAsInfered(singleOptionPath) ? 'yes' : 'no';
      }

      if (matcher.indexOf('array-ids:') > -1) {
        var _matcher$split = matcher.split(':'),
            _matcher$split2 = slicedToArray(_matcher$split, 3),
            _ = _matcher$split2[0],
            id = _matcher$split2[1],
            path = _matcher$split2[2];

        var _properValue = getAsInfered(singleOptionPath).find(function (v) {
          return v.id === id;
        });

        value = !_properValue ? 'no' : opg(path, _properValue) || 'no';
      }

      if (matcher.indexOf('json:') > -1) {
        value = getAsInfered(singleOptionPath + '/' + matcher.split(':')[1]).toString();
      }

      if (matcher === 'array_length') {
        var _properValue2 = getAsInfered(singleOptionPath);

        value = (_properValue2 || []).length.toString();
      }

      if (!value) {
        throw new Error('Unknown matcher received. Please verify for typos. The received matcher: ' + matcher + '.');
      }
    });

    /**
     * Matcher got _matched_.
     */
    if (value) {
      return value;
    } else {
      // Fall back to raw value check, but omit the matcher.
      singleOptionPath = singleOptionPath.split(':')[0];
    }
  }

  var properValue = getAsInfered(singleOptionPath);

  if (!properValue) return false;

  if (properValue.desktop) {
    return properValue;
  }

  return properValue.toString();
}

function tryToMatchValueWithOptionPath(maybeThat, singleOptionPath, inferedValuesForContext) {
  var properValue = extractScalarValueFor(singleOptionPath, inferedValuesForContext);

  if (maybeThat && maybeThat.toString() && maybeThat.toString().indexOf('~') === 0) {
    var toMatch = maybeThat.replace('~', '');

    if (properValue.desktop) {
      return properValue.desktop === toMatch || properValue.tablet === toMatch || properValue.mobile === toMatch;
    }

    return properValue === toMatch;
  }

  properValue = properValue.toString();
  maybeThat = maybeThat.toString();

  /**
   * The context value is not yet stabilized
   */
  if (!properValue) return false;

  /**
   * Pipe operator
   */
  if (maybeThat.indexOf('|') > -1) {
    if (maybeThat.indexOf('!') === 0) {
      return maybeThat.substring(1).split('|').map(function (el) {
        return el.trim();
      }).includes(properValue.trim()) === -1;
    } else {
      return maybeThat.split('|').map(function (el) {
        return el.trim();
      }).indexOf(properValue.trim()) > -1;
    }
  }

  /**
   * Negation operator
   */
  if (maybeThat.indexOf('!') === 0) {
    return properValue !== maybeThat.substring(1).trim();
  }

  /**
   * Contains operator
   */
  if (maybeThat.indexOf('*') === 0) {
    return properValue.indexOf(maybeThat.trim().substring(1).trim()) > -1;
  }

  /**
   * Simple equality
   */
  return properValue === maybeThat.trim();
}

export { opg, normalizeCondition, matchValuesWithCondition };
//# sourceMappingURL=index.es.js.map
